module.exports = __webpack_public_path__ + "static/media/attacgments.942c38bf.svg";